<template>
  <!-- 用户认证 -->
  <div class="person">
    <!-- 填写信息,成功或者未认证 -->
    <!-- 0 重新认证  undefined 未认证 1审核中  2 已通过  3  已驳回 -->
    <div v-if="formStatus.is_check == 2 || formStatus.is_check == undefined ||formStatus.is_check == 0 ">
      <div class="tit">用户认证</div>
      <div class="tixing">
        <i class="el-icon-info"></i>
        完成认证后可进行订舱操作，认证信息除手机号、邮箱外不可修改如需修改请联系客服
      </div>
      <!-- 营业执照 -->
      <div class="info">
        <div>
          <div><span>*</span>营业执照</div>
          <div class="tup">
            <el-upload
              class="avatar-uploader"
              action="https://serve.dhcang.com/api/upload/yyzz"
              :show-file-list="false"
              :headers="headers"
              :on-success="uploadYyzzImgSuccess"
              :disabled="formStatus.is_check == 2"
            >
              <img
                v-if="form.business_license"
                :src="form.business_license"
                class="upload"
                style="object-fit: cover;"
              />
              <div class="shangchuan" v-else>
                <img src="@/assets/images/update.png" alt="" />
                <div>上传营业执照</div>
              </div>
            </el-upload>
            <el-button
              v-if="form.business_license"
              class="YlBTN"
              type="text"
              @click="yulan(form.business_license)"
              >预览</el-button
            >
          </div>
        </div>
        <div>
          <div><span>*</span>电子名片</div>
          <div class="tup">
            <el-upload
              class="avatar-uploader"
              action="https://serve.dhcang.com/api/upload/image"
              :show-file-list="false"
              :on-success="uploadDzmpImgSuccess"
              :headers="headers"
              :disabled="formStatus.is_check == 2"
            >
              <img v-if="form.vcard" :src="form.vcard" class="upload" style="object-fit: cover;" />
              <div class="shangchuan" v-else>
                <img src="@/assets/images/update.png" alt="" />
                <div>上传电子名片</div>
              </div>
            </el-upload>
            <el-button
              v-if="form.vcard"
              class="YlBTN"
              type="text"
              @click="yulan(form.vcard)"
              >预览</el-button
            >
          </div>
        </div>
      </div>
      <div class="info">
        <div>
          <div><span>*</span>企业名称</div>
          <el-input
            v-model="form.enterprise_name"
            placeholder="请输入"
            :disabled="formStatus.is_check == 2"
          ></el-input>
        </div>
        <div>
          <div><span>*</span>企业联系人</div>
          <el-input :disabled="formStatus.is_check == 2" v-model="form.username" placeholder="请输入"></el-input>
        </div>
      </div>
      <!-- 邮箱 -->
      <!-- <div class="info emial"> -->
      <div class="info">
        <div>
          <div><span>*</span>电子邮箱</div>
          <el-input :disabled="formStatus.is_check == 2" v-model="form.email" placeholder="请输入"></el-input>
        </div>
        <!-- 60s后可重新发送 -->

        <!-- :class="{ 'is-active': emailTrue }" -->
        <div v-if="formStatus.is_check!=2" :class="{ 'emailyzm': form.email!='' && form.email!=undefined }" class="yanmzhengma" @click="getEmailCode">
          {{ second === totalSecond ? "获取验证码" : second + `秒后重新发送` }}
        </div>
      </div>
      <el-input v-if="formStatus.is_check!=2" v-model="form.email_code" placeholder="邮箱验证码"></el-input>

      <!-- <el-button class="wancheng">完成</el-button> -->
      <div class="info">
        <div v-show="form.qq!='' || form.qq!= undefined || form.qq!=null">
          <div>QQ</div>
          <el-input :disabled="formStatus.is_check==2" v-model="form.qq" placeholder="QQ微信最少填写一个"></el-input>
        </div>
        <div v-show="form.wechat!='' || form.wechat!= undefined || form.wechat!=null">
          <div>微信</div>
          <el-input :disabled="formStatus.is_check==2" v-model="form.wechat" placeholder="QQ微信最少填写一个"></el-input>
        </div>
      </div>

      <div class="tit">开票信息</div>
      <div class="tixing">
        <i class="el-icon-info"></i>
        完善开票信息后不可修改如需修改可联系平台客服处理
      </div>
      <div class="info">
        <div>
          <div><span>*</span>企业名称</div>
          <el-input
            v-model="form.enterprise_name"
            placeholder="请输入"
            :disabled="formStatus.is_check == 2"
          ></el-input>
        </div>
        <div>
          <div><span>*</span>税务登记号</div>
          <el-input :disabled="formStatus.is_check == 2" v-model="form.taxpayer_id" placeholder="请输入"></el-input>
        </div>
      </div>
      <div class="info">
        <div>
          <div><span>*</span>开户行(CNY)</div>
          <el-input
            v-model="form.cny_bank_name"
            placeholder="请输入"
            :disabled="formStatus.is_check == 2"
          ></el-input>
        </div>
        <div>
          <div><span>*</span>银行账号(CNY)</div>
          <el-input
            @blur="onBlur"
            v-model="form.cny_bank_account"
            placeholder="请输入"
            :disabled="formStatus.is_check == 2"
          ></el-input>
        </div>
      </div>
      <div class="info"  :class="{'zuihou':formStatus.is_check == 2}">
        <div>
          <div><span>*</span>开户行(USD)</div>
          <el-input
            v-model="form.usd_bank_name"
            placeholder="请输入"
            :disabled="formStatus.is_check == 2"
          ></el-input>
        </div>
        <div>
          <div><span>*</span>银行账号(USD)</div>
          <el-input
            @blur="onBlur"
            v-model="form.usd_bank_account"
            placeholder="请输入"
            :disabled="formStatus.is_check == 2"
          ></el-input>
        </div>
      </div>
      <el-button v-if="formStatus.is_check != 2" class="wancheng" @click="submit">提交</el-button>
    </div>
    <!-- 等待审核 -->
    <div v-if="formStatus.is_check == 1">
      <div class="shenhe">
        <i class="el-icon-time"></i>
        <div>认证审核中，请耐心等等</div>
        <el-button class="tijiao" @click="dialogFormVisible = true">
          查看认证信息
        </el-button>
      </div>
    </div>
    <!-- 已驳回 -->
    <div v-if="formStatus.is_check == 3">
      <div class="shenhe">
        <i class="el-icon-error"></i>
        <div>认证已驳回，<span class="reason" @click="reasonDialog = true">查看原因</span></div>
        <el-button class="tijiao" @click="formStatus.is_check = 0">
          重新认证
        </el-button>
      </div>
    </div>

    <el-dialog center title="用户认证信息" :visible.sync="dialogFormVisible">
      <div>
        <div class="tit dialog-tit">用户认证</div>
        <div class="tixing">
          <i class="el-icon-info"></i>
          完成认证后可进行订舱操作，认证信息除手机号、邮箱外不可修改如需修改请联系客服
        </div>
        <!-- 营业执照 -->
        <div class="info">
          <div>
            <div><span>*</span>营业执照</div>
            <div class="tup">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :on-success="handleSuccess"
                :disabled="formStatus.is_check == 1"
              >
                <img v-if="form.business_license" :src="form.business_license" class="upload" />
                <div class="shangchuan" v-else>
                  <img src="@/assets/images/update.png" alt="" />
                  <div>上传营业执照</div>
                </div>
              </el-upload>
              <el-button
                v-if="form.business_license"
                class="YlBTN"
                type="text"
                @click="yulan(form.business_license)"
                >预览</el-button
              >
            </div>
          </div>
          <div>
            <div><span>*</span>电子名片</div>
            <div class="tup">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :on-success="handleSuccess"
                :disabled="formStatus.is_check == 1"
              >
                <img v-if="form.vcard" :src="form.vcard" class="upload" />
                <div class="shangchuan" v-else>
                  <img src="@/assets/images/update.png" alt="" />
                  <div>上传电子名片</div>
                </div>
              </el-upload>
              <el-button
                v-if="form.vcard"
                class="YlBTN"
                type="text"
                @click="yulan(form.vcard)"
                >预览</el-button
              >
            </div>
          </div>
        </div>
        <div class="info">
          <div>
            <div><span>*</span>企业名称</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.enterprise_name" placeholder="请输入"></el-input>
          </div>
          <div>
            <div><span>*</span>企业联系人</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.username" placeholder="请输入"></el-input>
          </div>
        </div>
        <!-- 邮箱 -->
        <!-- <div class="info emial"> -->
        <div class="info">
          <div>
            <div><span>*</span>电子邮箱</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.email" placeholder="请输入"></el-input>
          </div>
          <div v-show="form.qq!=''">
            <div><span>*</span>QQ</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.qq" placeholder="请输入"></el-input>
          </div>
          <div  v-show="form.wechat!=''">
            <div><span>*</span>微信</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.wechat" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="tit">开票信息</div>
        <div class="tixing">
          <i class="el-icon-info"></i>
          完善开票信息后不可修改如需修改可联系平台客服处理
        </div>
        <div class="info">
          <div>
            <div><span>*</span>企业名称</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.enterprise_name" placeholder="请输入"></el-input>
          </div>
          <div>
            <div><span>*</span>税务登记号</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.taxpayer_id" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="info">
          <div>
            <div><span>*</span>银行账号(CNY)</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.cny_bank_account" placeholder="请输入"></el-input>
          </div>
          <div>
            <div><span>*</span>开户行(CNY)</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.cny_bank_name" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="info">
          <div>
            <div><span>*</span>银行账号(USD)</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.usd_bank_account" placeholder="请输入"></el-input>
          </div>
          <div>
            <div><span>*</span>开户行(USD)</div>
            <el-input :disabled="formStatus.is_check==1" v-model="form.usd_bank_name" placeholder="请输入"></el-input>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img class="tupp" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <!-- 驳回原因 -->
    <el-dialog
      title="驳回原因"
      center
      :visible.sync="reasonDialog"
      width="30%">
      <div class="dialog-con">{{formStatus.reject_reason}}</div>
      <div class="dialog-line"></div>
      <div  class="dialog-footer">
        <el-button class="dialog-guanbi" @click="reasonDialog = false">关闭</el-button>
        <el-button class="dialog-renzheng" @click="reasonDialog = false;formStatus.is_check = 0">重新认证</el-button>
      </div>
    </el-dialog>
  </div>
</template>
    
<script>
// 
import { userAuthenticationInfo, emailSendCode, userAuthenticationEdit } from "@/api/api";

export default {
  components: {},
  data() {
    return {
      form: {
        enterprise_name: "", // 企业名称
        username: "", // 联系人
        email: "", // 联系人邮箱
        email_code: "", // 联系人邮箱验证码
        business_license: "", // 营业执照
        vcard: "", // 电子名片
        taxpayer_id: "", // 企业税号
        cny_bank_name: "", // 开户行（CNY）
        cny_bank_account: "", // 银行账号（CNY）
        usd_bank_name: "", // 开户行（USD）
        usd_bank_account: "", // 银行账号（USD）
        qq:'',
        wechat:'',
        businessAddress:'',
      },
      formStatus:{
        is_check: "", // 认证审核状态：1待审核、2通过、3驳回
        reject_reason: "", // 驳回原因
      },
      //   vcard: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
      vcard: "",
      status: "0",
      dialogFormVisible: false,
      // 邮箱校验是否通过
      emailTrue: false,
      // 验证码倒计时
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
      headers: {
        token: localStorage.getItem("token"),
      },
      // 图片预览
      dialogVisible: false,
      dialogImageUrl: "",
      reasonDialog:false,
    };
  },
  methods: {
    handleSuccess(response, file, fileList) {
      console.log("上传成功！", response);
      console.log("上传的文件信息：", file);
      console.log("所有文件列表：", fileList);
      //   const res = response;
      //   this.form.business_license = res.data.url;
      //   this.form.enterprise_name = res.data.companyName;
      //   this.form.taxpayer_id = res.data.creditCode;
      //   this.loading = false;
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith("image/");
      const isValidSize = file.size / 1024 / 1024 < 100; // Limit file size to 10MB
      this.loading = true;
      if (!isImage) {
        this.$message.error("只能上传图片文件!");
        return false; // Prevent upload
      }
      if (!isValidSize) {
        this.$message.error("文件大小不能超过100MB");
        return false; // Prevent upload
      }
      return true; // Allow upload
    },
    yulan(e) {
      this.dialogImageUrl = e;
      this.dialogVisible = true;
    },
    // ^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$
    // 校验邮箱
    validFn() {
      if(this.form.email=='' || this.form.email==undefined){
        this.$message({
          // duration:0,
          message: "请输入邮箱地址",
          type: "error",
        });
        return false;
      } else if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          this.form.email
        )
      ) {
        // this.$toast('请输入正确的手机号')
        // alert('1121')
        // this.$message.error("请输入正确的手机号");
        this.$message({
          // duration:0,
          message: "请输入正确的邮箱地址",
          type: "error",
        });
        return false;
      }
      return true;
    },

    async getEmailCode() {
      // 判断邮箱验证是否通过
      if (!this.validFn()) {
        return;
      }
      // emailSendCode
      try {
        // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
        if (!this.timer && this.second === this.totalSecond) {
          // 开启倒计时
          this.timer = setInterval(() => {
            this.second--;

            if (this.second <= 0) {
              clearInterval(this.timer);
              this.timer = null; // 重置定时器 id
              this.second = this.totalSecond; // 归位
            }
          }, 1000);
          const resCode = await emailSendCode({
            email:this.form.email
          },this.headers);
          if (resCode.code == 1) {
            console.log(resCode, "获取成功");
          } else {
            console.log(resCode, "获取失败");
          }
        }else {
          this.$message({
            message: "您已发送！",
            type: "warning",
          });
        }
        
      } catch (error) {
        console.log(error,'失败');
      }
    },
    // 获取用户认证信息
    async getUserAuthentication() {
      let token = localStorage.getItem("token");
      let headers = {
        token: token,
      };
      try {
        const res = await userAuthenticationInfo(headers);
        if (res.code == 1 &&  res.data.id != undefined) {
          this.form.enterprise_name = res.data.enterprise_name;
          this.form.username = res.data.username;
          this.form.email = res.data.email;
          this.form.business_license = res.data.business_license;
          this.form.vcard = res.data.vcard;
          this.form.taxpayer_id = res.data.taxpayer_id;
          this.form.cny_bank_name = res.data.cny_bank_name;
          this.form.cny_bank_account = res.data.cny_bank_account;
          this.form.usd_bank_name = res.data.usd_bank_name;
          this.form.usd_bank_account = res.data.usd_bank_account;
          this.form.qq = res.data.qq;
          this.form.wechat = res.data.wechat;
          this.formStatus.is_check = res.data.is_check;
          this.formStatus.reject_reason = res.data.reject_reason;
          this.form.businessAddress = res.data.businessAddress

          // 更新本地用户认证信息
          let storedObject = localStorage.getItem('userInfo');
          if (storedObject) { 
            let obj = JSON.parse(storedObject);
            obj.is_authentication = res.data.is_check;
            obj.email = res.data.email;
            obj.enterprise_name = res.data.enterprise_name;
            localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
          }      
        }
      } catch (error) {
        console.log(error,"获取用户认证信息失败");
      }
    },
    // 图片上传成功
    async uploadYyzzImgSuccess(res) {
      if (res.code == 1) {
        this.form.business_license = res.data.uri;

        if (this.form.enterprise_name=='') {
          this.form.enterprise_name=res.data.companyName
        }

        if (this.form.taxpayer_id=='') {
          this.form.taxpayer_id=res.data.creditCode
        }
        
        this.$message({
          message: "上传成功",
          type: "success",
        });
        this.form.businessAddress = res.data.businessAddress;
        this.form.enterprise_name = res.data.companyName
        this.form.taxpayer_id = res.data.creditCode
      } else {
        this.$message({
          message: "上传失败",
          type: "error",
        });
      }
    },
    // 图片上传成功
    async uploadDzmpImgSuccess(res) {
      if (res.code == 1) {
        this.form.vcard = res.data.uri;
        this.$message({
          message: "上传成功",
          type: "success",
        });
      } else {
        this.$message({
          message: "上传失败",
          type: "error",
        });
      }
    },
    // 提交修改信息
    async submit(){
      console.log(1111,this.form.wechat,this.form.usd_bank_account);
      if(this.form.qq.trim() == '' && this.form.wechat.trim() == ''){
        this.$message({
          type:'error',
          message:'QQ微信最少需要输入一个'
        })
        return
      }
      try {
        const res = await userAuthenticationEdit(this.form,this.headers)
        if(res.code==0){
          this.$message({
            message: res.msg,
            type: "error",
          });
        }else if(res.code==1){
          this.$message({
            message: '提交成功，请等待审核',
            type: "success",
          });
          this.formStatus.is_check = 1
        }
      } catch (error) {
        console.log(error,'修改失败');
        
      }
    },
    // 认证信息
    onBlur(e){
      if(e.target.value == ''){
          return
        }
        if(!/\d$/.test(e.target.value)){
        this.$message({
          type:'error',
          message:'输入的内容应为六位数字'
        })
      }
    }
  },
  mounted() {
    this.getUserAuthentication();
  },
};
</script>
    
<style style lang="scss" scoped>
.person {
  padding: 0px 32px 0 32px;
  box-sizing: border-box;

  height: 100%;
  .tit {
    margin-top: 32px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;
  }

  .dialog-tit{
    margin-top: 0;
  }

  .tixing {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
    margin-top: 8px;
  }
  .info {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;

    display: flex;
    align-items: flex-end;
    margin-top: 24px;

    span {
      color: #fe3300;
    }
  }

  .emial {
    align-items: flex-end;
    .el-input {
      margin-right: 12px;
    }
  }
  :deep(.el-input) {
    input {
      width: 280px;
      height: 40px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      color: #333;
    }

    margin-right: 48px;
    margin-top: 12px;
  }

  .wancheng {
    width: 100px;
    height: 40px;
    background: #0073f5;
    border-radius: 8px 8px 8px 8px;
    color: #fff;
    border: 0;

    margin-top: 24px;
    margin-bottom: 32px;
  }

  .zuihou{
    margin-bottom: 32px;
  }

  .shangchuan {
    width: 280px;
    height: 168px;
    background: #f9f9f9;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #eeeeee;

    margin-top: 12px;
    margin-right: 48px;
    div {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;
      line-height: 14px;
    }

    img {
      width: 32px;
      height: 32px;

      margin-top: 52px;
      margin-bottom: 8px;
    }
  }
  .YlBTN {
    margin-left: 10px;
    margin-top: 140px;
    // background: #fff;
    // color: #0073F5;
    margin-right: 20px;
  }

  .tup {
    display: flex;
  }
  .upload {
    width: 280px;
    height: 168px;
    margin-top: 12px;
  }
}

.shenhe {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  font-style: normal;
  text-transform: none;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  i {
    font-size: 48px;
    color: #0073f5;
    border-radius: 50%;
    margin-bottom: 20px;
    margin-top: 176px;
  }

  .tijiao {
    width: 120px;
    height: 40px;
    border-radius: 56px 56px 56px 56px;
    border: 1px solid #0073f5;
    font-size: 14px;
    color: #0073f5;
    background: #fff;
    margin-top: 24px;
    margin-bottom: 147px;
  }

  span {
    color: #0073f5;
  }

  .el-icon-error {
    color: #fe3300;
  }
}

.yanmzhengma {
  cursor: pointer;
  line-height: 40px;
}

.emailyzm{
  color: #0073f5;
}
.tupp {
  width: 100%;
}

.reason{
  cursor: pointer;
}

.dialog-con{
  font-size: 14px;
  color: #666666;
}

.dialog-line{
  width: 100%;
  height: 1px;
  background: #EEEEEE;
  margin-bottom: 9px;
  margin-top: 32px;
}

.dialog-footer{
  text-align: right;
  .dialog-guanbi{
    width: 120px;
    height: 48px;
    background: #F9F9F9;
    border-radius: 8px 8px 8px 8px;
    font-size: 16px;
    color: #999999;
    border: 0;
  }

  .dialog-renzheng{
    width: 120px;
    height: 48px;
    background: #0073F5;
    border-radius: 8px 8px 8px 8px;
    font-size: 16px;
    color: #FFFFFF;
  }
}
</style>